import type { JobDeadlinePressure } from '@chukua/common';

/** Tag colour and label for a job's deadline pressure (gitaumoses4/chukua#39) — the day count is already server-computed, this is presentation only. */
export const DEADLINE_PRESSURE_LABELS: Record<JobDeadlinePressure, { label: string; color: string }> = {
  overdue: { label: 'Overdue', color: 'error' },
  due_soon: { label: 'Due soon', color: 'warning' },
};

/** `daysUntilDeadline` turns "Due soon" into "Due in 3d" / "Due today" — nothing to add for "Overdue", which already says enough. */
export function deadlinePressureLabel(pressure: JobDeadlinePressure, daysUntilDeadline: number | null): string {
  if (pressure === 'overdue') return DEADLINE_PRESSURE_LABELS.overdue.label;
  if (daysUntilDeadline === 0) return 'Due today';
  return `Due in ${daysUntilDeadline}d`;
}
